import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8'
    >
      <h1 className='text-3xl font-bold text-primary-light mb-6'>Privacy Policy</h1>

      <div className='bg-white rounded-lg shadow-md p-6'>
        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Information We Collect</h2>
          <p className='text-gray-600 leading-relaxed mb-4'>
            We collect information that you provide directly to us when using our verification
            service, including:
          </p>
          <ul className='list-disc list-inside text-gray-600 leading-relaxed'>
            <li>Product verification codes</li>
            <li>Search queries</li>
            <li>Device information</li>
            <li>Usage data</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>How We Use Your Information</h2>
          <p className='text-gray-600 leading-relaxed'>We use the collected information to:</p>
          <ul className='list-disc list-inside text-gray-600 leading-relaxed'>
            <li>Verify product authenticity</li>
            <li>Improve our services</li>
            <li>Analyze usage patterns</li>
            <li>Prevent fraud</li>
            <li>Comply with legal obligations</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Data Security</h2>
          <p className='text-gray-600 leading-relaxed'>
            We implement appropriate security measures to protect your information from unauthorized
            access, alteration, disclosure, or destruction. However, no method of transmission over
            the Internet is 100% secure, and we cannot guarantee absolute security.
          </p>
        </section>

        <section>
          <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Contact Us</h2>
          <p className='text-gray-600 leading-relaxed'>
            If you have any questions about our Privacy Policy, please contact us at:
          </p>
          <ul className='list-none text-gray-600 leading-relaxed mt-2'>
            <li>Email: privacy@Natco Pharmacy.com</li>
            <li>Phone: +1 (555) 123-4567</li>
            <li>Address: 123 Medical Plaza, Healthcare City</li>
          </ul>
        </section>
      </div>
    </motion.div>
  );
};

export default Privacy;
